import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './page.component';
import { ContactComponent } from '@cargeny/pages/contact/contact.component';
import { UnsubscribeComponent } from '@cargeny/pages/unsubscribe/unsubscribe.component';
import { NotFoundComponent } from '@cargeny/pages/not-found/not-found.component';
import { SignUpComponent } from '@cargeny/pages/sign-up/sign-up.component';
import { ForgotPasswordComponent } from '@cargeny/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '@cargeny/pages/reset-password/reset-password.component';
import { AboutComponent } from '@cargeny/pages/about/about.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { SignInComponent } from '@cargeny/pages/sign-in/sign-in.component';
import { ServiceComponent } from '@cargeny/pages/service/service.component';
import { environmentConfigFactory } from '@shared/factories/environment-config.factory';
import { environment } from '@cargeny/environments/environment';

const routesPath = environmentConfigFactory(environment).routes;
const routes: Routes = [
  {
    path: '',
    component: PageComponent,
    children: [
      {
        path: routesPath.services,
        loadChildren: () => import('@cargeny/pages/services/service.module').then((m) => m.ServiceModule),
      },
      {
        path: routesPath.articles,
        loadChildren: () => import('@cargeny/pages/articles/article.module').then((m) => m.ArticleModule),
      },
      {
        path: routesPath['sign-in'],
        canActivate: [AuthGuard],
        component: SignInComponent,
      },
      {
        path: routesPath['sign-up'],
        canActivate: [AuthGuard],
        component: SignUpComponent,
      },
      {
        path: routesPath.contact,
        component: ContactComponent,
      },
      {
        path: routesPath.unsubscribe,
        component: UnsubscribeComponent,
      },
      {
        path: routesPath['forgot-password'],
        component: ForgotPasswordComponent,
      },
      {
        path: routesPath['reset-password'],
        component: ResetPasswordComponent,
      },
      {
        path: routesPath.about,
        component: AboutComponent,
      },
      {
        path: routesPath.service,
        component: ServiceComponent,
      },
      {
        path: routesPath['not-found'],
        component: NotFoundComponent,
      },
      {
        path: '',
        loadChildren: () => import('@cargeny/pages/globals/global.module').then((m) => m.GlobalModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule {}
